var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-register-pre',{attrs:{"content":_vm.content,"prior-description":_vm.priorDescription},on:{"agree":_vm.agree,"to-login":_vm.toLogin}})}
var staticRenderFns = []

export { render, staticRenderFns }